export class Summary {
	private prices: Map<number, number> = new Map();
	private total: number = 0.0;
	private hypo: HTMLAnchorElement = document.querySelector('.hypo-kalkulacka');
	private discount: number = 0;
	private mobileTable: HTMLDivElement;

	public constructor() {
		this.mobileTable = document.querySelector('#configurator-old > .configurator-summary');
		this.initMobileTable();

		this.discount = parseInt((this.getSummaryTables()[0] ?? {discount: 0}).dataset.discount);
		this.update();
	}

	private initMobileTable() {
		if (this.mobileTable) {
			this.mobileTable.querySelector('.summary-mobile-toggle').addEventListener('click', () => {
				this.mobileTable.classList.toggle('show');
			})
		}

		const plotPrice = this.mobileTable.querySelector('[data-id="plot"] .category-price') as HTMLTableCellElement;
		if (plotPrice && plotPrice.dataset.value) {
			this.plotPrice = parseInt(plotPrice.dataset.value);
		}
		const basePrice = this.mobileTable.querySelector('[data-id="base"] .category-price') as HTMLTableCellElement;
		if (basePrice && basePrice.dataset.value) {
			this.basePrice = parseInt(basePrice.dataset.value);
		}
	}

	async refresh(project : number|null = null, plot: number|null = null) {
		const searchParams = new URLSearchParams;
		searchParams.set('action', 'konfigurator_summary');
		searchParams.set('nonce', esoul_konfigurator_params.nonce);
		if (project) {
			searchParams.set('project', project.toString());
		}
		if (plot) {
			searchParams.set('plot', plot.toString());
		}
		const response = await fetch(esoul_konfigurator_params.ajaxUrl, {
			method: 'POST',
			headers: {"Content-Type": "application/x-www-form-urlencoded"},
			body: searchParams,
		});
		if (!response.ok) {
			return;
		}
		const wrapper = document.createElement('div');
		wrapper.innerHTML = await response.text();

		this.mobileTable.replaceWith(wrapper.firstElementChild);
		this.mobileTable = document.querySelector('#configurator-old > .configurator-summary');
		this.discount = parseInt(this.mobileTable.dataset.discount);
		this.initMobileTable();
		this.update();
	}

	private _plotPrice: number = 0.0;

	set plotPrice(value: number) {
		console.log('plotPrice', value);
		this._plotPrice = value;
	}

	private _basePrice: number = 0.0;

	set basePrice(value: number) {
		console.log('basePrice', value);
		this._basePrice = value;
	}

	public clearPrices() {
		this.prices.clear();
		return this;
	}

	public update() {
		this.sumTotal();
		this.getSummaryTables().forEach(table => {
			const basePriceWrapper = table.querySelector(`[data-id="base"] .category-price`) as HTMLTableCellElement;
			if (basePriceWrapper) {
				basePriceWrapper.innerText = ((this._plotPrice ?? 0) + (this._basePrice ?? 0)).toLocaleString(undefined, {
					style: 'currency', currency: 'CZK', maximumFractionDigits: 0
				});
			}
			this.prices.forEach((price, id) => {
				const priceWrapper = table.querySelector(`[data-id="${id}"] .category-price`) as HTMLTableCellElement;
				if (priceWrapper) {
					priceWrapper.innerText = price.toLocaleString(undefined, {
						style: 'currency', currency: 'CZK', maximumFractionDigits: 0
					});
				}
			});
			const totals = table.querySelectorAll<HTMLTableCellElement>('.total');
			for (const total of totals) {
				total.innerText = this.total.toLocaleString(undefined, {
					style: 'currency', currency: 'CZK', maximumFractionDigits: 0,
				});
			}
		});
		return this;
	}

	public setPrices(prices: { [index: number]: number }) {
		Object.entries(prices).forEach(([id, price]) => {
			this.prices.set(parseInt(id), price);
		});
		return this;
	}

	public setPrice(id: number, price: number) {
		this.prices.set(id, price);
		return this;
	}

	public getHistoryParamsObject(): { [index: string]: number|string } {
		let params: { [index: string]: number|string } = Object.fromEntries(new URLSearchParams(window.location.search));
		this.prices.forEach((value, key) => {
			params[`e${key}`] = value;
		});
		return params;
	}

	public getHistoryParams(): string {
		let params = '';
		this.prices.forEach((value, key) => {
			params += `&e${key}=${value}`;
		});
		return params;
	}

	private getSummaryTables(): NodeListOf<HTMLDivElement> {
		return document.querySelectorAll('.configurator-summary');
	}

	private sumTotal(): number {
		this.total = this._plotPrice + this._basePrice;
		this.prices.forEach(price => {
			this.total += price;
		});
		if (this.discount > 0) {
			this.total -= this.discount;
		}
		this.hypo.href = window.location.origin + `/hypotecni-kalkulacka/?price=${this.total}`;
		return this.total;
	}

}
